import { useState } from "react";
import { Link } from "react-router-dom";
import { MobileBottomNav } from "./MobileBottomNav";
import { MobileMoreMenu } from "./MobileMoreMenu";
import { MobileViewSwitcher } from "./MobileViewSwitcher";
import { useDeviceType } from "@/hooks/use-device-type";
import logoImage from "@/assets/logo-optimized.webp";

interface MobileAppLayoutProps {
  children: React.ReactNode;
}

export function MobileAppLayout({ children }: MobileAppLayoutProps) {
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);
  const { isLandscape } = useDeviceType();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Mobile Header - smaller in landscape */}
      <header className={`sticky top-0 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border z-40 ${isLandscape ? 'h-10' : 'h-14'}`}>
        <div className="flex items-center justify-between px-4 h-full">
          <Link to="/" className="flex items-center gap-2">
            <img 
              src={logoImage} 
              alt="SpeisekartenCheck" 
              className={`rounded-lg ${isLandscape ? 'h-6 w-6' : 'h-8 w-8'}`}
              width={32}
              height={32}
              loading="eager"
            />
            <span className={`font-semibold text-foreground ${isLandscape ? 'text-xs' : 'text-sm'}`}>SpeisekartenCheck</span>
          </Link>
          <MobileViewSwitcher />
        </div>
      </header>

      {/* Content Area */}
      <main className={`flex-1 overflow-y-auto ${isLandscape ? 'pb-14' : 'mobile-content-padding'}`}>
        {children}
      </main>

      {/* Bottom Navigation - compact in landscape */}
      <MobileBottomNav onMoreClick={() => setMoreMenuOpen(true)} />

      {/* More Menu Sheet */}
      <MobileMoreMenu open={moreMenuOpen} onOpenChange={setMoreMenuOpen} />
    </div>
  );
}
